module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0078.png.a8c9359e.jpg";